import { BooleanList, IAdobeInteraction } from "@abbvie-epi/common/models";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { AnalyticsHelperService } from "../../../services/analytics-helper.service";

@Component({
    selector: "app-table2",
    templateUrl: "./table2.component.html",
    styleUrls: ["./table2.component.scss"]
})
export class Table2Component implements OnInit {
    @Output() closeModalEvent: EventEmitter<void> = new EventEmitter<void>();

    private readonly ACCORDION_TAG_PREFIX: string = "developing-the-tool-table-2-accordion-";

    public dropdownList: BooleanList = {
        dropdown1: false,
        dropdown2: false,
        dropdown3: false,
        dropdown4: false,
        dropdown5: false,
        dropdown6: false,
        dropdown7: false,
        dropdown8: false,
        dropdown9: false,
        dropdown10: false
    };

    private baseAccordionAnalytics: IAdobeInteraction | null = null;

    constructor(private analyticsHelper: AnalyticsHelperService) {}

    async ngOnInit(): Promise<void> {
        this.baseAccordionAnalytics = await this.analyticsHelper.getInteractionById("global-modal-accordion-base");
    }

    closeModal() {
        this.closeModalEvent.emit();
    }

    public toggleDropdown(dropdownNumber: string) {
        const tagBase = `${this.ACCORDION_TAG_PREFIX}${dropdownNumber}`;

        const selectedDropdown: string = `dropdown${dropdownNumber}`;
        const activeDropdown = Object.keys(this.dropdownList).find((key) => this.dropdownList[key] === true);

        if (selectedDropdown !== activeDropdown) {
            this.analyticsHelper.trackInteraction(`${tagBase}-expand`, this.baseAccordionAnalytics || undefined);
        } else {
            this.analyticsHelper.trackInteraction(`${tagBase}-close`, this.baseAccordionAnalytics || undefined);
        }

        if (activeDropdown && activeDropdown !== selectedDropdown) {
            this.dropdownList[activeDropdown] = false;
        }

        this.dropdownList[selectedDropdown] = !this.dropdownList[selectedDropdown];
    }
}
